export const selectPage = (state) => state?.page;
export const selectPagePrevPath = (state) => selectPage(state)?.prevPath;
export const selectPagePrevSearchParams = (state) => selectPage(state)?.prevSearchParams;
